import { insuranceAutoPayUpcoming, insuranceBillWithRevalOffer } from "../builders/createInsuranceBill";
import { MockPolicyId } from "../mockPolicies";
import { testDriveMember } from "../mockMembers";
import { getMockPolicies } from "../builders/getMockPolicies";
import { cigAutoPayBill, cigRevalBill } from "../builders/createCigBill";

import { MockPersona } from "./mockPersonas.types";

const usPolicies: MockPolicyId[] = ["5R34843-01", "EA108939-01"];

export const frankReynolds: MockPersona = {
  key: "frankReynolds",
  name: "Frank Reynolds",
  description:
    "🇺🇸 | Two core policies | No HDC | One Upcoming Insurance Bill (autopay) + One Reval + One Esign | Failed Streaming",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [
          cigAutoPayBill({ id: "1", productNumber: usPolicies[0] }),
          cigRevalBill({ id: "2", productNumber: usPolicies[1] }),
        ],
      },
      policies: {
        usa: getMockPolicies(...usPolicies),
        canada: [],
      },
    },
    esign: {
      fetchESignDocuments: [{ Id: 1, StateRegion: "GA" }],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
      stream: "error",
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "frank@reynolds.com",
            firstName: "Frank",
            middleName: "",
            lastName: "Reynolds",
            mailingAddress: {
              line1: "9241 Roosevelt Blvd",
              line2: "",
              city: "Philadelphia",
              state: "PA",
              postalCode: "19114",
              country: "USA",
            },
            preferredPhone: "2152098523",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000010",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [
            insuranceAutoPayUpcoming({ id: "1", policyNumber: usPolicies[0] }),
            insuranceBillWithRevalOffer({ id: "2", policyNumber: usPolicies[1] }),
          ],
          outstandingBalance: 100,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
